import { callPlatformAPI } from '@f_utils/callPlatformAPI';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { Property, TypeDataList } from '../type';
import { CrossdataContext } from './Crossdata_context';

const ReportListContext = createContext<any>({});

const POLL_INTERVAL_MS = 5000;
// Предохранитель: перестаём опрашивать зависшую задачу примерно через 20 минут,
// чтобы старые (до фикса бэкенда) карточки не крутили опрос бесконечно.
const MAX_POLL_ATTEMPTS = 240;

type TypeSendList = {
    data: TypeDataList;
    title: string;
    cross: boolean;
    applicationWorkspaceId: number;
    status: string;
    currency: string;
    periodStart: string;
    periodEnd: string;
};

function ReportListProvider(props: any) {
    const { workspaceApplicationId } = useContext(CrossdataContext);
    const [taskList, setTaskList] = useState<any>([]);
    const [configList, setConfigList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const pollAttemptsRef = useRef(0);
    const pollTimerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        if (!workspaceApplicationId || workspaceApplicationId === -1) return;
        getTaskList();
        getConfigList();
        return () => {
            if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
        };
    }, [workspaceApplicationId]);

    const getConfigList = async () => {
        const result = await callPlatformAPI(`crossdata/get/property/${Property.ListSettingReport}`, 'get');
        console.log('getConfigList', result);
        if (result.data.isOk) {
            setConfigList(result.data.result.value);
        }
        return result.data;
    };

    const sendList = async (data: TypeSendList) => {
        const result = await callPlatformAPI('crossdata/send/list', 'post', data);
        console.log('sendList', result);
        if (result.data.isOk) {
            setTaskList([result.data.result, ...taskList]);
            getTaskList();
        }
        return result.data;
    };

    const getTaskList = async (isPoll = false) => {
        setIsLoading(true);
        try {
            const result = await callPlatformAPI(`crossdata/get/tasks/${workspaceApplicationId}`, 'get');
            console.log('getTaskList', result);
            if (result.data.isOk) {
                setTaskList(result.data.result);

                pollAttemptsRef.current = isPoll ? pollAttemptsRef.current + 1 : 0;
                const hasPending = result.data.result.some((item: any) => !item.finishReport);

                if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
                if (hasPending && pollAttemptsRef.current < MAX_POLL_ATTEMPTS) {
                    pollTimerRef.current = setTimeout(() => {
                        getTaskList(true);
                    }, POLL_INTERVAL_MS);
                }
            }
        } catch (err) {
            console.error('getTaskList failed', err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteTask = async (refKey: string) => {
        const result = await callPlatformAPI(`crossdata/delete/task/${workspaceApplicationId}/${refKey}`, 'delete');
        console.log('getTaskList', result);
        if (result.data.isOk) {
            await getTaskList();
        }
        return result.data;
    };

    return (
        <ReportListContext.Provider
            value={{
                taskList,
                isLoading,
                configList,

                //methods
                sendList,
                deleteTask,
            }}
            {...props}
        />
    );
}

export { ReportListContext, ReportListProvider };
